// Per asking from the reading pane and compose team, new file created to avoid increasing bundle size.

import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() => import('./lazyIndex'));

// Delayed loaded actions/functions
export const lazyOpenFilePickerFromSmartDoc = new LazyImport(
    lazyModule,
    m => m.openFilePickerFromSmartDoc
);
